module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/john-gorrie-534.3357022a138477fd.jpg"+" 534w",
        images: [{path: "https://static.sniffspot.com/packs/img/john-gorrie-534.3357022a138477fd.jpg",width: 534,height: 590}],
        src: "https://static.sniffspot.com/packs/img/john-gorrie-534.3357022a138477fd.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/john-gorrie-534.3357022a138477fd.jpg"},
        
        width: 534,
        height: 590
      }